export default {
  title: {
    id: 'buyback_offer_title',
    defaultMessage: 'Trade-in',
  },
  priceOffer: {
    id: 'buyback_offer_price_offer',
    defaultMessage: 'Your price offer:',
  },
  congratsOffer: {
    id: 'buyback_offer_congrats_offer',
    defaultMessage: 'Congrats on your offer!',
  },
  secondLife: {
    id: 'buyback_offer_second_life',
    defaultMessage: 'Give your device a second life.',
  },
  savvySellers: {
    id: 'buyback_offer_savvy_sellers',
    defaultMessage: 'Join more than 2M savvy sellers on Trade-in.',
  },
  sellFor: {
    id: 'buyback_offer_sell_for',
    defaultMessage: 'Sell for {price}',
  },
  summary: {
    id: 'buyback_offer_summary',
    defaultMessage: 'Device summary',
  },
}
